import { render } from "./Scalability.vue?vue&type=template&id=87d32988&scoped=true"
import script from "./Scalability.vue?vue&type=script&lang=js"
export * from "./Scalability.vue?vue&type=script&lang=js"

import "./Scalability.vue?vue&type=style&index=0&id=87d32988&lang=scss&scoped=true"

import exportComponent from "/Applications/CODE/mickwebsite/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87d32988"]])

export default __exports__